import { computed, onMounted, onBeforeUnmount, ref } from "vue";
import {
  BANOBAGI_CONNECTION_CUTOFF,
  BANOBAGI_RECEIPT_CUTOFF,
  BANOBAGI_SITE_CUTOFF,
  BANOBAGI_SITE_OPEN_AT,
  isBanobagiAvailabilityEnabled,
  isBanobagiConnectionClosed,
  isBanobagiReceiptClosed,
  isBanobagiSiteClosed
} from "@/utils/banobagiAvailability";

// เรียงจากน้อยไปมากเพื่อให้ตั้งเวลาปลุกที่เส้นตายที่ใกล้ที่สุดเสมอ
// (บาง cutoff ชี้เวลาเดียวกันได้ เช่น connection ที่ผูกกับ site)
const BANOBAGI_DEADLINES = [
  BANOBAGI_SITE_OPEN_AT,
  BANOBAGI_RECEIPT_CUTOFF,
  BANOBAGI_CONNECTION_CUTOFF,
  BANOBAGI_SITE_CUTOFF
].sort((a, b) => a - b);

export function useBanobagiAvailability() {
  const now = ref(Date.now());
  let timer;

  function refreshAvailability() {
    clearTimeout(timer);
    now.value = Date.now();
    if (!isBanobagiAvailabilityEnabled()) return;
    const deadline = BANOBAGI_DEADLINES.find(value => value > now.value);
    if (deadline) {
      timer = setTimeout(
        refreshAvailability,
        Math.min(deadline - now.value, 60000)
      );
    }
  }

  onMounted(() => {
    refreshAvailability();
    window.addEventListener("focus", refreshAvailability);
    document.addEventListener("visibilitychange", refreshAvailability);
  });
  onBeforeUnmount(() => {
    clearTimeout(timer);
    window.removeEventListener("focus", refreshAvailability);
    document.removeEventListener("visibilitychange", refreshAvailability);
  });

  return {
    isConnectionClosed: computed(() => isBanobagiConnectionClosed(now.value)),
    isReceiptClosed: computed(() => isBanobagiReceiptClosed(now.value)),
    isSiteClosed: computed(() => isBanobagiSiteClosed(now.value)),
    refreshAvailability
  };
}
